import { render, staticRenderFns } from "./customer-stat-bar.vue?vue&type=template&id=5f62d902"
import script from "./customer-stat-bar.vue?vue&type=script&lang=js"
export * from "./customer-stat-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/johnson/WebStormProject/zm/zm-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f62d902')) {
      api.createRecord('5f62d902', component.options)
    } else {
      api.reload('5f62d902', component.options)
    }
    module.hot.accept("./customer-stat-bar.vue?vue&type=template&id=5f62d902", function () {
      api.rerender('5f62d902', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/charts/customer-stat-bar.vue"
export default component.exports